/* unplugin-vue-components disabled */import { render } from "./dalateqiapp.vue?vue&type=template&id=185bb73c&scoped=true"
import script from "./dalateqiapp.vue?vue&type=script&lang=js"
export * from "./dalateqiapp.vue?vue&type=script&lang=js"

import "./dalateqiapp.vue?vue&type=style&index=0&id=185bb73c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185bb73c"]])

export default __exports__